import { render, staticRenderFns } from "./visua.vue?vue&type=template&id=6def5767&scoped=true"
import script from "./visua.vue?vue&type=script&lang=js"
export * from "./visua.vue?vue&type=script&lang=js"
import style0 from "./visua.vue?vue&type=style&index=0&id=6def5767&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6def5767",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6def5767')) {
      api.createRecord('6def5767', component.options)
    } else {
      api.reload('6def5767', component.options)
    }
    module.hot.accept("./visua.vue?vue&type=template&id=6def5767&scoped=true", function () {
      api.rerender('6def5767', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data/goods/components/visua.vue"
export default component.exports